import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { OcDatePicker } from "oc/components";
import { getDateFormatByLocale } from "oc/utils";
import type { TFunction } from "i18next";

export interface OcValidToInputFieldProps {
  /** Current value, as a Date or null */
  value: Date | null;
  /** Setter for the value */
  setValue: (date: Date | null) => void;
  /** Validation error flag */
  error: boolean;
  /** Setter for the error flag */
  setError: (error: boolean) => void;
  /** Validation helper text */
  helperText: string;
  /** Setter for the helper text */
  setHelperText: (text: string) => void;
  /** Secondary error flag (e.g. from parent) */
  errorInput?: boolean;
  /** Secondary helper text (e.g. from parent) */
  helperTextInput?: string;
  /** Optional focus handler */
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
}

export const OcValidToInputField: FC<OcValidToInputFieldProps> = ({
  value,
  setValue,
  error,
  setError,
  helperText,
  setHelperText,
  errorInput = false,
  helperTextInput = "",
}) => {
  const { t, i18n }: { t: TFunction; i18n: any } = useTranslation();

  useEffect(() => {
    return () => {
      setValue(null);
      setError(false);
      setHelperText("");
    };
  }, [setValue, setError, setHelperText]);

  const formattedValue: Date | null = value ? new Date(value) : null;

  const handleChange = (date: Date | null): void => {
    setValue(date);
  };

  return (
    <OcDatePicker
      error={error || errorInput}
      helperText={error ? helperText : helperTextInput}
      id="user-profile-valid-to-field"
      label={t("OC_VALID_TO")}
      minDate={new Date()}
      //minDateMessage={t("OC_NOT_SELECTABLE")}
      onChange={handleChange}
      value={formattedValue}
      //onFocus={onFocus}
      format={getDateFormatByLocale(i18n.language)}
    />
  );
};

OcValidToInputField.displayName = "OcValidToInputField";

export default OcValidToInputField;
